import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmChartIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmChartIcon = ({ className, ...props }: EmChartIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_286_33611)">
      <path
        d="M21.3125 0.6875H0.6875V21.3125H21.3125V0.6875Z"
        fill="white"
      />
      <path
        d="M21.3123 4.18512H0.957153"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.34375"
      />
      <path
        d="M21.3124 7.50574H0.940063"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.34375"
      />
      <path
        d="M21.3124 10.8264H0.921143"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.34375"
      />
      <path
        d="M21.3124 14.147H0.903931"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.34375"
      />
      <path
        d="M21.3124 17.4693H0.88501"
        stroke="#B0BEC5"
        strokeMiterlimit="10"
        strokeWidth="0.34375"
      />
      <path
        d="M6.65499 20.9533H3.76233V9.51842C3.76233 9.28467 3.95139 9.09561 4.18514 9.09561H6.23217C6.46592 9.09561 6.65499 9.28467 6.65499 9.51842V20.9533Z"
        fill="#9CCC65"
      />
      <path
        d="M12.4472 20.9533H9.55286V12.8631C9.55286 12.6294 9.74192 12.4403 9.97567 12.4403H12.0227C12.2564 12.4403 12.4455 12.6294 12.4455 12.8631V20.9533H12.4472Z"
        fill="#F44336"
      />
      <path
        d="M17.8131 20.9533H15.7661C15.5323 20.9533 15.3433 20.7642 15.3433 20.5305V4.44469C15.3433 4.21094 15.5323 4.02188 15.7661 4.02188H17.8131C18.0469 4.02188 18.2359 4.21094 18.2359 4.44469V20.5305C18.2359 20.7642 18.0469 20.9533 17.8131 20.9533Z"
        fill="#0091EA"
      />
      <path
        d="M21.3125 20.625H1.375V0.6875H0.6875V21.3125H21.3125V20.625Z"
        fill="#B0BEC5"
      />
      <path
        d="M20.9688 1.03125V20.9688H1.03125V1.03125H20.9688ZM21.3125 0.6875H0.6875V21.3125H21.3125V0.6875Z"
        fill="#B0BEC5"
      />
    </g>
    <defs>
      <clipPath id="clip0_286_33611">
        <rect
          fill="white"
          height="22"
          width="22"
        />
      </clipPath>
    </defs>
  </svg>
);

export default EmChartIcon;
